
/**
 * Takes raw incoming data from the API and applies some extra sugar.
 *
 * @param    {Object}  printSession  The print-session data
 * @returns  {Object}  The transformed data
 * @public
 */
exports.transformPrintSession = function(printSession) {
    return printSession;
};
